var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-left-bar-preview"},[_c('pages-list'),_vm._v(" "),(_vm.transitionPresets.length)?_c('transition-panel'):_vm._e(),_vm._v(" "),(_vm.overlayTracks.length)?_c('overlay-media-picker'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }